import type { ValidatorFn } from '@angular/forms';
import type { CardTypes } from '@shared/enums/auth.enums';
import type { EParcelPlacesFormControlNames } from '../parcel-places.enums';

export enum CodeUKTZEDGoodsType {
  Electronics = 'Electronics',
  CarParts = 'CarParts',
  Perfumes = 'Perfumes',
  HandWatches = 'HandWatches',
}

export type IICodeUKTZEDCategoryData = Record<CodeUKTZEDGoodsType, IICodeUKTZEDCategoryDataItem>;

export interface IICodeUKTZEDCategoryDataItem {
  regexList: RegExp[];
  categoryName: string;
  categoryExample: string;
  affectedControls: IICodeUKTZEDAffectedControl[];
  affectedUserTypes?: CardTypes[];
}

export interface IICodeUKTZEDAffectedControl {
  controlName: EParcelPlacesFormControlNames;
  validators: ValidatorFn[];
  defaultValidators: ValidatorFn[];
}
